import ArrowIcon from "@icons/arrowIcon.svg";
import ChevronIcon from "@icons/chevronIcon.svg";
import { SwiperSlide } from "swiper/react";
import { ILearning } from "@kunduz/data-access-learning-api";
import styles from "./learningConceptItem.module.scss";
import { LearningCarousel } from "@kunduz/feature-learning-ui";
import LearningMaterialItem from "../materialItem/learningMaterialItem";
import { getContentUrl, ReservedWords } from "@kunduz/utility-common";

export const LearningConceptItem = (props: Props) => {
  const LinkElement = props.linkAs ?? "a";

  return (
    <div className={styles["container"]}>
      <div className={styles["conceptHeader"]}>
        <div>
          <span className={styles["numberContainer"]}>{props.index + 1}</span>
          <h2 className={styles["conceptName"]}>
            <LinkElement
              href={getContentUrl({
                lang: props.lang,
                contentType: ReservedWords.TR_CONTENT_CONCEPT,
                segments: [props.moduleSlug, props.conceptSlug],
              })}
            >
              {props.name}
            </LinkElement>
          </h2>
        </div>
        <div className={styles["viewAll"]}>
          {props.isMobile ? (
            <ChevronIcon width={20} />
          ) : (
            <>
              {props.viewAllText}
              <ArrowIcon />
            </>
          )}
        </div>
      </div>
      <div className={styles["conceptDescription"]}>{props.shortDesc}</div>
      {props.materials.length > 0 && (
        <LearningCarousel
          perView={3}
          spaceBetween={16}
          swipeItemsLength={Number(props.materials.length)}
          isMobile={props.isMobile}
        >
          {props.materials?.map((material) => (
            <SwiperSlide key={material.id}>
              <LearningMaterialItem
                name={material.name}
                slug={getContentUrl({
                  lang: props.lang,
                  contentType: ReservedWords.TR_CONTENT_MATERIAL,
                  segments: [
                    props.moduleSlug,
                    props.conceptSlug,
                    material.slug,
                  ],
                })}
                description={material.seo_meta.short_desc}
                thumbnail={material.thumbnail}
                preview={material.preview}
                type="module"
                lang={props.lang}
                linkAs={props.linkAs}
              />
            </SwiperSlide>
          ))}
        </LearningCarousel>
      )}
    </div>
  );
};

interface Props {
  isMobile: boolean;
  index: number;
  name: string;
  materials: ILearning.LearningMaterialByModule[];
  shortDesc: string;
  viewAllText: string;
  linkAs?: React.ElementType;
  lang: "tr" | "en";
  moduleSlug: string;
  conceptSlug: string;
}
